// Public pages must not mount authenticated app utilities or be displaced by
// a background request that discovers an expired session.
export function isPublicRoute(pathname = '') {
  const path = pathname.split(/[?#]/)[0].replace(/\/+$/, '') || '/';
  return [
    '/', '/welcome', '/login', '/signup', '/forgot-password',
    '/reset-password', '/privacy', '/terms', '/sms-policy',
  ].includes(path) || /^\/(?:invite|book|schedule|v|p)\/[^/]+$/.test(path)
    || /^\/schedule\/rr\/[^/]+$/.test(path);
}

export function shouldMountAppUtilities(pathname, token, agent) {
  return Boolean(token && agent && !isPublicRoute(pathname));
}
